import React ,{useEffect, useState}from 'react';
import Grid from '@mui/material/Grid'
import Loading from "./Loading";
import './App.css';
import Logo from './images/Hungertip.PNG'

function App() {
	const [opacity,setOpacity] = useState(0)
	useEffect(()=>{
		setOpacity(1)
	},[])
	const ellipsisStyle = {
    	position: 'absolute',
      top: '50%',
      left: '50%',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
			padding:'1rem'
  };
	const isMobile = navigator?.userAgentData?.mobile || true;

  return (
    <Grid className="App" style={ellipsisStyle} container justifyContent='center' alignItems='center'>
			<Grid style={{transition: 'opacity 3s ease-in-out',opacity,marginBotton:isMobile?'-5rem':''}} container justifyContent='center' alignItems='center'>
      	<img src={Logo} alt="HungerTip" width={isMobile?"150":"600"} height={isMobile?"80":"400"}/>
			</Grid>
			<Loading isMobile={isMobile} text='Coming soon'/>
			<Grid style={{fontWeight:'999',marginBottom:isMobile?0:'-1rem',fontSize:isMobile?'1rem': '3rem'}}>
				<span className="dot-one"> .</span>
				<span className="dot-two"> .</span>
				<span className="dot-three"> .</span>
			</Grid>
    </Grid>
  );
}

export default App;
